var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService, SFUN } from '../../services/common.service';
import { UsuarioService } from '../../services/usuario.service';
import { ExpedienteService } from '../../services/expediente.service';
import { RepreCausaPopupComponent } from './repre-causa-popup.component';
import { ServiceException } from '../../model/exception';
import { Message } from '../../common/dialog/mensaje.component';
import { MensajeConfig } from '../../common/dialog/mensaje.config';
import { KeycloakService } from '../../services/keycloak.service';
var ChildTable = (function () {
    function ChildTable() {
        this.onDelete = new EventEmitter();
    }
    ChildTable.prototype.deleteRepre = function (index) {
        this.details.splice(index, 1);
        this.onDelete.emit();
    };
    return ChildTable;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ChildTable.prototype, "onDelete", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ChildTable.prototype, "details", void 0);
ChildTable = __decorate([
    Component({
        selector: 'child-table',
        styles: ['table{width:100%}'],
        template: "\n    <table class=\"table\">\n      <thead>\n        <tr>\n          <td class=\"ctth-0\">Caracter</td>\n          <td class=\"ctth-0\">Documento</td>\n          <td class=\"ctth-0\">Nombre y Apellido</td>\n          <td class=\"ctth-0\"></td>\n        </tr>\n      </thead>\n      <tbody>\n        <ng-template ngFor let-repre [ngForOf]=\"details\" let-rowIndex=\"index\">\n            <tr>\n            <td class=\"ctth-1\">{{repre.tipoVin.descr}}</td>\n            <td class=\"ctth-1\">{{repre.tdo_cod}} {{repre.numero}}</td>\n            <td class=\"ctth-1\">{{repre.nombre}} {{repre.apellido}}</td>\n            <td class=\"ctth-1\">\n                <div class=\"cursorHand\" (click)=\"deleteRepre(rowIndex)\">\n                    <i class=\"fa fa-trash-o tama\u00F1oIcono\" aria-hidden=\"true\"></i>\n                </div>\n            </td>\n            </tr>\n        </ng-template>\n      </tbody>\n    </table>\n  "
    })
], ChildTable);
export { ChildTable };
var PartesCausaComponent = (function () {
    function PartesCausaComponent(_usrService, _comService, _expService) {
        this._usrService = _usrService;
        this._comService = _comService;
        this._expService = _expService;
        this.tex_cod = "";
        this.conexo = false;
        this.onComplete = new EventEmitter(false);
        this.ErrorMsgR = "";
        this.ErrorMessageIsVisibleR = false;
        this.isEnabledPer = false;
        this.tipoVinculo = { cod: "", descr: "", id: 0, tipo: 0, excluirForcar: false };
        this.partes = [];
        this.parte = { per_id: 0, parte: "", rep_codigo: "", tipoVin: this.tipoVinculo, vinculo: "", apellido: "", nombre: "", numero: "", tdo_cod: "", tip_id: 0, tip_cod: "", domicilio: "", usaDomRenaper: false, genero: "", usaRenaper: false, representantes: [] };
        this.isFisica = true;
        this.personaBuscada = { per_id: 0, parte: "", rep_codigo: "", tipoVin: this.tipoVinculo, vinculo: "", apellido: "", nombre: "", numero: "", tdo_cod: "", tip_id: 0, tip_cod: "", domicilio: "", usaDomRenaper: false, genero: "", usaRenaper: false, representantes: [] };
        this.permisoUsaRenaper = false;
        this.isEnabledModPer = false;
        this.isEnabledPerDom = false;
        this.MsgPartesConexo = "";
        this.visibleMsg = false;
        this.verAceptar = true;
        this._openedDetails = [];
        this.instanceId = Math.floor(Math.random() * 1000000);
    }
    PartesCausaComponent.prototype.ngOnInit = function () {
        // this._comService.findParteCausaExample().subscribe(response => {
        //     this.partes = response;
        //     this.validateData();
        // });
        var _this = this;
        this.hideErrorMsg();
        this.hideErrorMsgConexo();
        this.setPermisos();
        this.findGeneros();
        this._comService.findTiposVinculo(this.tex_cod).subscribe(function (response) {
            _this.tviList = response;
            _this.tviListParte = _this.tviList.filter(function (item) { return item.tipo == 0; });
            _this.tviListRepre = _this.tviList.filter(function (item) { return item.tipo == 1; });
        });
        this._comService.findTiposPersona().subscribe(function (response) {
            _this.tipList = response;
        });
        this._comService.findTiposDocumentos().subscribe(function (response) {
            _this.tdocList = response;
        });
        this._comService.findTiposDocumentosJur().subscribe(function (response) {
            _this.tdocListJur = response;
        });
    };
    PartesCausaComponent.prototype.findTiposVunculoByConcepto = function () {
        var _this = this;
        this._comService.findTiposVinculoByConcepto(this.tex_cod, this.ttr_id).subscribe(function (response) {
            _this.tviList = response;
            _this.tviListParte = _this.tviList.filter(function (item) { return item.tipo == 0; });
            _this.tviListRepre = _this.tviList.filter(function (item) { return item.tipo == 1; });
        });
    };
    PartesCausaComponent.prototype.setPermisos = function () {
        if (typeof (KeycloakService.usr) !== 'undefined' && typeof (KeycloakService.usr.permisos) !== 'undefined') {
            this.permisoUsaRenaper = this._comService.tienePermiso(SFUN.ICUsaRenaper);
        }
    };
    PartesCausaComponent.prototype.findGeneros = function () {
        var _this = this;
        this._comService.findGeneros().subscribe(function (response) {
            _this.generoList = response;
        });
    };
    PartesCausaComponent.prototype.buscarPerConexo = function (exp_idConexo) {
        var _this = this;
        this._expService.findPersonasConexo(exp_idConexo + "", this.ttr_id).subscribe(function (response) {
            //console.log("find personas " + JSON.stringify(response));
            _this.partes = response;
            _this.showMsgPartesConexo();
        }, function (error) {
            var exc = ServiceException.parse(error.json());
            _this.isEnabledPer = true;
            //console.log(exc.toString());
            _this.parte.nombre = "";
            _this.parte.apellido = "";
            _this.parte.per_id = 0;
            _this.mensajeConfigSource = new MensajeConfig("Busqueda de Personas", false, "", true, "Aceptar");
            _this.msgPopup.showMessage(exc.getDescripcion());
        });
    };
    PartesCausaComponent.prototype.showMsgPartesConexo = function () {
        this.verAceptar = true;
        // this.MsgTipos = "Ha elegido crear un tipo de expediente EXP, desea continuar? De caso contrario, vuelva a comenzar."; //this._comService.getConfiguracion("MSGCONEXP");
        this.MsgPartesConexo = this._comService.getConfiguracion("MSGCONPAR");
        this.visibleMsg = true;
        this.validateData();
    };
    PartesCausaComponent.prototype.onClickOK = function () {
        this.visibleMsg = false;
        this.MsgPartesConexo = "";
    };
    PartesCausaComponent.prototype.onClickBuscarPer = function () {
        var _this = this;
        this.hideErrorMsg();
        if (this.permisoUsaRenaper && this.parte.tip_cod == 'PFI' && this.parte.tdo_cod == 'DNI') {
            this.parte.usaRenaper = true;
        }
        else {
            this.parte.usaRenaper = false;
        }
        if (this.parte.tip_id !== 0 && this.parte.tdo_cod !== "" && this.parte.numero !== "") {
            this._expService.findPersona(JSON.stringify(this.parte)).subscribe(function (response) {
                _this.isEnabledPer = false;
                _this.personaBuscada = response;
                _this.parte.nombre = response.nombre;
                _this.parte.apellido = response.apellido;
                _this.parte.per_id = response.per_id;
                _this.parte.domicilio = response.domicilio;
                _this.parte.usaRenaper = response.usaRenaper;
                if (_this.parte.usaRenaper) {
                    _this.isEnabledModPer = false;
                    _this.isEnabledPerDom = false;
                    _this.parte.usaDomRenaper = true;
                    _this.personaBuscada.usaDomRenaper = true;
                }
                else {
                    _this.isEnabledModPer = true;
                    _this.isEnabledPerDom = true;
                    _this.parte.usaDomRenaper = false;
                    _this.personaBuscada.usaDomRenaper = false;
                }
            }, function (error) {
                //var exc = ServiceException.parse(error.json());
                //console.log("exception: " + exc.toString());
                _this.isEnabledPer = true;
                //console.log(exc.toString());
                _this.parte.nombre = "";
                _this.parte.apellido = "";
                _this.parte.per_id = 0;
                _this.parte.usaDomRenaper = false;
                _this.isEnabledPerDom = true;
                //alert(exc.description);
                _this.mensajeConfigSource = new MensajeConfig("Busqueda de Personas", false, "", true, "Aceptar");
                //this.msgPopup.showMessage(exc.getDescripcion());
                _this.msgPopup.showMessage("No se encontro la Persona");
                //that.modalEscritoEvent(SIGNER_STATUS.CLOSED.code);
                // that._comService.emitBlocking(false);
            });
        }
        else {
            this.ErrorMsgB = "Para buscar una persona debe seleccionar el Tipo de Persona, Tipo de Documento y Nro de Documento";
            this.ErrorMessageIsVisibleB = true;
        }
    };
    PartesCausaComponent.prototype.onChangeSelect = function (selected) {
    };
    PartesCausaComponent.prototype.onChangeSelectTvi = function (selected) {
        var vinculo;
        vinculo = this.tviListParte.find(function (item) { return item.id == selected; });
        //console.log("Vinculo " + JSON.stringify(vinculo));
        this.parte.tipoVin = vinculo;
        this.parte.vinculo = vinculo.descr;
        if (vinculo.cod != "ACT") {
            this.isEnabledPer = true;
        }
        else {
            this.isEnabledPer = false;
        }
    };
    PartesCausaComponent.prototype.onChangeSelectTipo = function (selected) {
        this.isFisica = true;
        var tip;
        tip = this.tipList.find(function (item) { return item.id == selected; });
        this.parte.tip_cod = tip.codigo;
        if (tip.codigo == "PFI") {
            this.isFisica = true;
        }
        else {
            this.isFisica = false;
        }
    };
    PartesCausaComponent.prototype.onChangeSelectGenero = function (selected) {
        var gen;
        gen = this.generoList.find(function (item) { return item.id == selected; });
        this.parte.genero = gen.cod;
    };
    PartesCausaComponent.prototype.onClickAgregar = function () {
        this.hideErrorMsg();
        if (this.validateDataPer()) {
            //console.log("parte buscada " + JSON.stringify(this.personaBuscada));
            //console.log(" == " + (JSON.stringify(this.personaBuscada) != "undefined"));
            if (JSON.stringify(this.personaBuscada) !== "undefined") {
                if (this.parte.nombre !== this.personaBuscada.nombre || this.parte.apellido !== this.personaBuscada.apellido) {
                    //console.log("SE MODIFICO NOMBRE O APELLIDO");
                    this.parte.per_id = 0;
                    this.parte.usaRenaper = false;
                    this.parte.usaDomRenaper = false;
                }
                if (this.parte.domicilio !== this.personaBuscada.domicilio) {
                    //console.log("SE MODIFICO EL DOMICILIO");
                    this.parte.domicilio = this.parte.domicilio.toUpperCase();
                    this.parte.usaDomRenaper = false;
                }
            }
            this.partes.push(this.parte);
            this.tipoVinculo = { cod: "", descr: "", id: 0, tipo: 0, excluirForcar: false };
            this.parte = { per_id: 0, parte: "", rep_codigo: "", tipoVin: this.tipoVinculo, vinculo: "", apellido: "", nombre: "", numero: "", tdo_cod: "", tip_id: 0, tip_cod: "", domicilio: "", usaDomRenaper: false, genero: "", usaRenaper: this.permisoUsaRenaper, representantes: [] };
            this.isFisica = true;
            this.isEnabledPer = false;
        }
        this.validateData();
    };
    PartesCausaComponent.prototype.deleteParte = function (index) {
        this.partes.splice(index, 1);
        this.validateData();
    };
    PartesCausaComponent.prototype.validateDataPer = function () {
        //console.log("validatePer " + JSON.stringify(this.parte));
        if (this.parte.tipoVin.id == 0) {
            this.showErrorMessage("Debe seleccionar el Tipo de Vinculo");
            return false;
        }
        if (this.parte.tip_cod == "") {
            this.showErrorMessage("El Tipo de Persona no puede ser vacío");
            return false;
        }
        if (this.parte.tipoVin.cod == "ACT" && this.parte.tdo_cod == "") {
            this.showErrorMessage("El Tipo de Documento no puede ser vacío");
            return false;
        }
        if (this.parte.tipoVin.cod == "ACT" && this.parte.numero == "") {
            this.showErrorMessage("El Número de documento no puede ser vacío");
            return false;
        }
        if (this.parte.nombre.trim() == "") {
            this.showErrorMessage("El Nombre de la persona no puede ser vacío");
            return false;
        }
        if (this.isFisica && this.parte.apellido.trim() == "") {
            this.showErrorMessage("El Apellido de la persona no puede ser vacío");
            return false;
        }
        if (this.parte.domicilio == null || this.parte.domicilio.trim() == "") {
            this.showErrorMessage("El Domicilio no puede ser vacío");
            return false;
        }
        return true;
    };
    PartesCausaComponent.prototype.addRepre = function (index) {
        this._comService.emitBlocking(true);
        this.reprePopup.newRepre();
        this.indexParte = index;
    };
    PartesCausaComponent.prototype.onCompleteRepre = function (ev) {
        if (this.partes[this.indexParte].representantes == null) {
            this.partes[this.indexParte].representantes = [];
        }
        this.partes[this.indexParte].representantes.push(ev);
        this.validateData();
    };
    PartesCausaComponent.prototype.isDetailsOpen = function (i) {
        return this._openedDetails.indexOf(i) > -1;
    };
    PartesCausaComponent.prototype.toggleDetails = function (i) {
        var index = this._openedDetails.indexOf(i);
        if (index > -1)
            this._openedDetails.splice(index, 1);
        else
            this._openedDetails.push(i);
    };
    PartesCausaComponent.prototype.onDeleteRepre = function (ev) {
        if (this.partes[ev].representantes.length == 0) {
            this.toggleDetails(ev);
        }
        this.validateData();
    };
    PartesCausaComponent.prototype.validateData = function () {
        this.showErrorRepre(false);
        if (this.partes.length == 0) {
            this.onComplete.emit(false);
            return;
        }
        else {
            if (this.partes.length > 0) {
                for (var i = 0; this.partes.length > i; i++) {
                    if (this.partes[i].representantes != null && this.partes[i].representantes.length > 0) {
                        this.onComplete.emit(true);
                        return;
                    }
                }
                this.showErrorRepre(true);
                this.onComplete.emit(false);
                return;
            }
        }
        this.onComplete.emit(true);
    };
    PartesCausaComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    PartesCausaComponent.prototype.showErrorRepre = function (val) {
        if (val)
            this.ErrorMsgR = "Al menos unas de las partes debe tener un Representante";
        else
            this.ErrorMsgR = "";
        this.ErrorMessageIsVisibleR = val;
    };
    PartesCausaComponent.prototype.hideErrorMsg = function () {
        this.ErrorMsgB = "";
        this.ErrorMessageIsVisibleB = false;
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
    };
    PartesCausaComponent.prototype.hideErrorMsgConexo = function () {
        //console.log("hide msg");
        this.MsgPartesConexo = "";
        this.visibleMsg = false;
    };
    PartesCausaComponent.prototype._keyPress = function (event) {
        //console.log('keypress');
        var pattern = /[.,\-+]/;
        var inputChar = String.fromCharCode(event.charCode);
        if ((event.charCode != 0 && pattern.test(inputChar)) || event.charCode == 101) {
            event.preventDefault();
        }
    };
    PartesCausaComponent.prototype.verificarMaxLength = function (event) {
        /* let nroDocumento = documento.toString();
         
         console.log(nroDocumento.length);
         if(nroDocumento.length>15){
             nroDocumento = nroDocumento.slice(0,15);
             this.parte.numero = null;
             this.parte.numero = nroDocumento;
             console.log(this.parte.numero);
         }
         */
        var documento = event.target.value;
        //console.log('doc',documento);
        //console.log('length', documento.length);
        if (documento.length > 15) {
            this.parte.numero = documento.slice(0, 15);
            //console.log('this.parte.numero',this.parte.numero);
            event.target.value = documento.slice(0, 15);
            //console.log('event.target.value',event.target.value);
        }
    };
    return PartesCausaComponent;
}());
__decorate([
    Input(),
    __metadata("design:type", String)
], PartesCausaComponent.prototype, "tex_cod", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PartesCausaComponent.prototype, "conexo", void 0);
__decorate([
    ViewChild(RepreCausaPopupComponent),
    __metadata("design:type", RepreCausaPopupComponent)
], PartesCausaComponent.prototype, "reprePopup", void 0);
__decorate([
    ViewChild(ChildTable),
    __metadata("design:type", ChildTable)
], PartesCausaComponent.prototype, "childTable", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PartesCausaComponent.prototype, "onComplete", void 0);
__decorate([
    ViewChild(Message),
    __metadata("design:type", Message)
], PartesCausaComponent.prototype, "msgPopup", void 0);
PartesCausaComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'partes-causa',
        templateUrl: 'partes-causa.component.html'
    }),
    __metadata("design:paramtypes", [UsuarioService,
        CommonService, ExpedienteService])
], PartesCausaComponent);
export { PartesCausaComponent };
//# sourceMappingURL=partes-causa.component.js.map